//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import { validatePhone,validateNull,validateVerify,validateCode} from '../../utils/validate';
  import Xinput from '../../components/Xinput.vue'
  var count=60;
  export default {
  name: 'register',
  data(){
    return{
      //col-12
      col3:"col-3",
      col4:"col-4",
      col5:"col-5",
      col6:"col-6",
      col8:"col-8",
      col9:"col-9",
      col12:"col-12",

      //cols-100
      cols22:"cols-22",
      cols78:"cols-78",

      //电话
      tel:"",
      tel_save:"",
      tel_msg:'',
      tel_name:'手机号',
      tel_class:"form-control",
      tel_Placeholder:"输入手机号",

      //按钮状态 用于表单验证

      submit_btn_disabled:true,
      submit_btn_class:"btn btn-blue",
   
      //校验码
      verify_name:'校验码',
      verify_Placeholder:"输入右侧字符",
      verify_img:"",
      verify_class:"form-control",
      verify_value:"",
      verify_return:"",
      verify_class:"form-control",


      //短信验证码
      code_name:'验证码',
      code_Placeholder:"输入短信验证码",
      code_class:"form-control",
      code_btn_value:"获取验证码",
      code_value:"",
      code_return:"",
      code_lock:true,
      code_btn_disabled:true,
      code_btn_class:"btn btn-orange",
      code_class:"form-control con-code",
      sessionId:Date.parse(new Date()),
     

      //其他
      time:"",
      icon_remove:false,

   
      type:{
            tel:"tel",
            text:"text",
            email:"email",
        }

    }
  },
  created: function(){
   
    this.tel = this.$route.params.tel;
    this.getCaptcha();

  },
  components: {
    Xinput
  },
  methods: {
  
  //处理手机号表单状态
  handleTel: function(str){
    this.tel = str;

    if(this.tel==""){
      this.tel_class = "form-control";
      this.tel_msg = "";

    }
    else if(this.tel.length == "11" ){
      if( this.tel_save == "" || this.tel_save == this.tel){
        //save为空 或者 两者相等
      }else{
        //save不为空 或者 两者不同 -- 刷新验证码清空
        this.sessionId = Date.parse(new Date());
        this.getCaptcha();
        this.verify_value = "";
        
      }

      if (validatePhone(this.tel)){
        this.tel_class = "form-control"
        this.tel_msg = "";
      }else{
        this.tel_class = "form-control input-error";
        this.tel_msg = "输入的手机号不正确";
      }
      this.doCheck();
    }else{
      this.tel_class = "form-control";
      this.tel_msg = "";
      this.doCheck();
    }
     
  },
  handleTelBlur: function(str){
    var self = this;


    setTimeout(function(){    

      self.tel = str;
      if(!(self.tel)){
          self.tel = "";
      }
    
      if(self.tel==""){
        self.tel_class = "form-control";
        self.tel_msg = "";
      }
      else{   
        if (validatePhone(self.tel)){
          self.tel_class = "form-control"
          self.tel_msg = "";
        }else{
          self.tel_class = "form-control input-error";
          self.tel_msg = "输入的手机号不正确";
        }
        self.doCheck();
      } 
    }, 300);  
  },
  //处理校验图片状态
  handleVerify:function(str){
     this.verify_value = str;
    if(this.verify_value == ""){
      this.verify_class = "form-control"
      this.verify_return = "";

    }else if(this.verify_value.length == "4" ){
      if(!validateVerify(this.verify_value)){
          this.verify_class = "form-control input-error"
          this.verify_return = "校验码不正确";      
      }
      else{
         this.verify_class = "form-control"
         this.verify_return = "";
      }
      this.doCheck();
    }else{
      this.verify_class = "form-control"
      this.verify_return = "";
      this.doCheck();
    }

  },
  handleVerifyBlur:function(str){
    this.verify_value = str;
    if(this.verify_value == ""){
      this.verify_class = "form-control"
      this.verify_return = "";

    }else{
      if(!validateVerify(this.verify_value)){
          this.verify_class = "form-control input-error"
          this.verify_return = "校验码不正确";      
      }
      else{
         this.verify_class = "form-control"
         this.verify_return = "";
      }
      this.doCheck();
    }
  },
  //处理校验图片状态
  //
  handleCode:function(str){
    this.code_value = str;
    if(this.code_value == ""){
      this.code_class = "form-control con-code",
      this.code_return = "";
    }else if (this.code_value.length == "6"){

      if(!validateCode(this.code_value)){
        this.code_class = "form-control con-code input-error",
        this.code_return = "短信验证码填写不正确"; 
      }
      else{
        this.code_class = "form-control con-code",
        this.code_return = "";
      }
      this.doCheck();
    }else{
      this.code_class = "form-control con-code",
      this.code_return = "";
      this.doCheck();
    }

  },
  handleCodeBlur:function(str){
    this.code_value = str;
    if(this.code_value == ""){
      this.code_class = "form-control con-code",
      this.code_return = "";
    }else{
      if(!validateCode(this.code_value)){
        this.code_class = "form-control con-code input-error",
        this.code_return = "短信验证码填写不正确"; 
      }
      else{
        this.code_class = "form-control con-code",
        this.code_return = "";
      }
      this.doCheck();
    }
  },
select:function(){

},
  //检查code按钮是否可以点击
/*  doCodeCheck:function(){
 
    if( validatePhone(this.tel) && validateNull(this.verify_value) && this.code_btn_value =="获取验证码"){
      return true;

    }else{
      //this.handleTelphone();
      this.handleVerify()
    }
  },*/
  //检查表单填写完整
  doCheck:function(){
    //检测获取验证码 状态
    if (validatePhone(this.tel) && validateVerify(this.verify_value) && this.code_lock){
      this.code_btn_disabled = false;

    } 
    else{
      this.code_btn_disabled = true;
    }
    //检测下一步状态
    if(validatePhone(this.tel) && validateVerify(this.verify_value) && validateCode(this.code_value)){
      this.submit_btn_disabled = false; 
    }   
    else{
      this.submit_btn_disabled = true; 
    }
  },

  times(){
    var self = this;
    var a = setInterval(function() {
      self.code_btn_value = count+"秒";
      
      count--
      if(count<=0){
        clearInterval(a);
        count=60;
        self.code_btn_value = "重新发送";
        self.code_btn_disabled=false;
        self.code_lock=true; 
      }},1000)
    },
     
      getCaptcha:function(){

        /*this.verify_img = this.HOST + '/json/global_register/get-gcaptcha.action?sessionId=' + this.sessionId +'&r='+ Math.random();*/
        this.verify_img = '/json/global_register/get-gcaptcha.action?sessionId=' + this.sessionId +'&r='+ Math.random();

        this.$refs.verify.clear();
        this.doCheck();
      },

      sendCaptch:function(){
       
        var self = this;

        /*var url = this.HOST + '/json/global_register/validate-gcaptcha.action?loginName='+ this.tel +'&sessionId='+ this.sessionId + '&gcaptcha=' +this.verify_value;*/
        var url = '/json/global_register/validate-gcaptcha.action?loginName='+ this.tel +'&sessionId='+ this.sessionId + '&gcaptcha=' +this.verify_value;
        self.code_btn_disabled=true;
        self.tel_save = self.tel;

        if(validatePhone(this.tel) && validateVerify(this.verify_value)){
          this.submit_btn_value="再次获取";
         $.ajax({
            url,
            type: 'GET',
            timeout: 10000,
            error:function(){
              self.$vux.toast.show({text:'连接超时',type:'text',time:4000})
              self.code_btn_disabled=false;
            },
            success:function (responseText){
              var status = responseText.status;
              var statusText = responseText.statusText;
              /*
                Result 返回参数说明
                {
                  status=0 表示成功 102001 校验码错误，100000 系统异常，101002 图形验证码已失效， 101003 发送失败，101004 频率过多

                  statusText='返回的文案'
                }
              */
              if (status == 102001 ) {
                self.code_btn_disabled=false;
                self.$vux.toast.show({text:'校验码错误',type:'text',position: 'middle',time:4000}); 

              }else if (status == 100000) {
                self.code_btn_disabled=false;
                self.$vux.toast.show({text:'系统异常',type:'text',position: 'middle',time:4000});
              }
              else if (status == 101002) {
                self.code_btn_disabled=false;
                self.$vux.toast.show({text:'图形验证码已失效',type:'text',position: 'middle',time:4000});
                
              }
              else if (status == 101003) {
                self.code_btn_disabled=false;
                self.$vux.toast.show({text:'发送失败',type:'text',position: 'middle',time:4000});
              }
              else if (status == 101004) {
                self.code_btn_disabled=false;
                self.$vux.toast.show({text:'频率过多',type:'text',position: 'middle',time:4000});
              }
              else if (status == 0) {
                self.times();
                self.code_btn_disabled=true;

                //self.$vux.toast.show({text:'开始发送短信倒计时',type:'text',position: 'middle',time:4000});

                self.code_lock=false; 
                
              }
              else{               
                self.code_btn_disabled=false;
                self.$vux.toast.show({text:'其他',type:'text',position: 'middle',time:4000});
              }

            }
          })
      }},
      
doSubmit:function(){

  //如果没注册去注册，否则去exist
  var telephone = $.trim(this.tel);
  var code_value = $.trim(this.code_value);
  var self = this;
  /*var url = this.HOST + '/json/global_register/submit-loginName.action?loginName='+ telephone +'&captcha='+ code_value;*/
  var url = '/json/global_register/submit-loginName.action?loginName='+ telephone +'&captcha='+ code_value;
  if(validatePhone(this.tel) && validateVerify(this.verify_value) && validateCode(this.code_value)){

    self.submit_btn_disabled = true; 
   
    $.ajax({
        url,
        type: 'GET',
        timeout: 10000,
        error:function(){
        
          self.$vux.toast.show({text:'连接超时',type:'text',time:4000})
            self.submit_btn_disabled = false; 

        },
        success:function (responseText) {
        var status = responseText.status;
        var statusText = responseText.statusText;
        //"status": 0 表示成功, 101005 表示验证码失效 ，100000 手机号或者验证码为空，101001 验证码错误
        if (status == 101005 ) {
          self.submit_btn_disabled = false; 
          self.$vux.toast.show({text:'验证码失效',type:'text',position: 'middle',time:4000});
        }else if(status == 101001) {
          self.submit_btn_disabled = false; 
          self.$vux.toast.show({text:'验证码错误',type:'text',position: 'middle',time:4000});
        }
        else if(status == 100000) {
          self.submit_btn_disabled = false; 
          self.$vux.toast.show({text:'手机号或者验证码为空',type:'text',position: 'middle',time:4000});
        }
        else if (status == 0) {

          //"tenants": [] 如果数组为空表示未注册过，反之为注册过
          if(responseText.data.tenants.length > 0){
              self.$router.push({
              name: 'exist', 
              params: {tel: self.tel,accountStatus:true}
            })
          }else{
            self.$router.push({
              name: 'init',
              params: {tel: self.tel,code_value: self.code_value}
            })
          }
        }
        else {
          self.submit_btn_disabled = false; 
          self.$vux.toast.show({text:'其他错误',type:'text',position: 'middle',time:4000});
        }
      }
    })
  }
}}}



// WEBPACK FOOTER //
// ./src/views/register/index.vue